import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/nav_analytics_event.py
export const NAV_ANALYTICS_ACTIONS = {
  CREATED_SAVED_SEARCH: {
    module: ANALYTICS_MODULE.NAVIGATION,
    action: 'created_saved_search',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DELETED_SAVED_SEARCH: {
    module: ANALYTICS_MODULE.NAVIGATION,
    action: 'deleted_saved_search',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  EDITED_SAVED_SEARCH: {
    module: ANALYTICS_MODULE.NAVIGATION,
    action: 'edited_saved_search',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OPENED_SAVED_SEARCH: {
    module: ANALYTICS_MODULE.NAVIGATION,
    action: 'opened_saved_search',
    actionCategory: ACTION_CATEGORY.READ,
  },
  INSERTED_SAVED_SEARCH: {
    module: ANALYTICS_MODULE.NAVIGATION,
    action: 'inserted_saved_search',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  APPLIED_SORTS: {
    module: ANALYTICS_MODULE.NAVIGATION,
    action: 'applied_sorts',
    actionCategory: ACTION_CATEGORY.READ,
  },
  ADDED_SORT: {
    module: ANALYTICS_MODULE.NAVIGATION,
    action: 'added_sort',
    actionCategory: ACTION_CATEGORY.READ,
  },
  REMOVED_SORT: {
    module: ANALYTICS_MODULE.NAVIGATION,
    action: 'removed_sort',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_HELP_BUTTON: {
    module: ANALYTICS_MODULE.NAVIGATION,
    action: 'clicked_help_button',
    actionCategory: ACTION_CATEGORY.READ,
  },
  INITIALIZED_APP: {
    module: ANALYTICS_MODULE.NAVIGATION,
    action: 'initialized_app',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_RELEVANT_OBJECT: {
    module: ANALYTICS_MODULE.NAVIGATION,
    action: 'opened_relevant_object',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_RELEVANT_TEMPLATES_TAB: {
    module: ANALYTICS_MODULE.NAVIGATION,
    action: 'opened_relevant_templates_tab',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_RELEVANT_TEMPLATES_ADMIN_HELP: {
    module: ANALYTICS_MODULE.NAVIGATION,
    action: 'opened_relevant_templates_admin_help',
    actionCategory: ACTION_CATEGORY.READ,
  },
};
